import { render } from "./BanksForm.vue?vue&type=template&id=015d06e4&scoped=true"
import script from "./BanksForm.vue?vue&type=script&lang=js"
export * from "./BanksForm.vue?vue&type=script&lang=js"

import "./BanksForm.vue?vue&type=style&index=0&id=015d06e4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015d06e4"]])

export default __exports__